import { useEffect, useState, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router'
import { Container, CircularProgress, Box, Alert } from '@mui/material'
import { getConnection, fetchPRSheetData } from '../services/salesforce'
import { generatePRSheetHTML } from '../services/pdfGenerator'

export default function PreviewPage() {
  const { careerId } = useParams<{ careerId?: string }>()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [htmlContent, setHtmlContent] = useState<string>('')

  // セッションクリアしてログイン画面に戻る
  const handleSessionExpired = useCallback(() => {
    localStorage.removeItem('sf_access_token')
    localStorage.removeItem('sf_instance_url')
    navigate('/')
  }, [navigate])

  useEffect(() => {
    async function loadPreview() {
      const conn = getConnection()
      if (!conn) {
        setError('認証が切れています')
        setLoading(false)
        return
      }

      // careerIdがない場合はlocalStorageから取得
      let effectiveCareerId = careerId
      if (!effectiveCareerId) {
        effectiveCareerId = localStorage.getItem('sf_career_id') || undefined
      }

      if (!effectiveCareerId) {
        setError('CareerIDを指定してください')
        setLoading(false)
        return
      }

      try {
        // データを読み込む
        const prSheetData = await fetchPRSheetData(conn, effectiveCareerId)

        // HTMLを生成
        const html = await generatePRSheetHTML(prSheetData)
        setHtmlContent(html)
      } catch (err) {
        console.error('プレビュー読み込みエラー:', err)

        // セッションエラーの場合はログイン画面にリダイレクト
        const errorMessage = err instanceof Error ? err.message : String(err)
        if (errorMessage.includes('INVALID_SESSION_ID') || errorMessage.includes('Session expired')) {
          handleSessionExpired()
          return
        }

        setError('プレビューの読み込みに失敗しました')
      } finally {
        setLoading(false)
      }
    }

    loadPreview()
  }, [careerId, handleSessionExpired])

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Container>
        <Alert severity="error" sx={{ mt: 4 }}>
          {error}
        </Alert>
      </Container>
    )
  }

  return (
    <Box textAlign={'center'}>
      <div
        dangerouslySetInnerHTML={{ __html: htmlContent }}
        style={{ maxWidth: '660px', margin: '20px auto', textAlign: 'left' }}
      ></div>
    </Box>
  )
}
